import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { MAIN_BUTTONS } from "../data/main-buttons";
import _ from "lodash";
import { store } from "../../components/Store";
import { usePersonalAccountPermissions } from "../../hooks/use-personal-account-permissions";

/**
 * Componente que muestra los botones en la sección principal de ayuda
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} MainHelp
 */
export const MainHelp = ({ interfaceTexts }) => {
	const globalState = useContext(store);
	const { state } = globalState;
	const isAuth = state.sesionActiva === "SI";
	const buttons = [...MAIN_BUTTONS];
	const isPersonalAccount = state?.isPersonalAccount;
	const personalAccountPermissions = usePersonalAccountPermissions();
	const profileButtonEnabled = isPersonalAccount
		? true
		: (personalAccountPermissions.hasPermission("create") && !personalAccountPermissions.hasPermission("alternative-association-flow"));

	return (
		<>
			<h2>{interfaceTexts?.titulo || "Encuentra el tutorial perfecto para ti"}</h2>

			<div className="d-flex flex-wrap mt-4">
				{buttons.map((btn) => {
					const card = () => {
						return (
							<div key={btn?.id} className="col-sm-6">
								<Link
									to={btn?.url}
									className="btn-tutorial-ayuda"
									aria-label={`${interfaceTexts?.ir || "Ir a"} ${_.get(interfaceTexts, btn?.name?.translationPath) || btn?.name?.default}`}
								>
									<div className="i-btn-tuto">
										<Icon className="i-tuto" icon={btn?.icon} />
									</div>
									{_.get(interfaceTexts, btn?.name?.translationPath) ||
										btn?.name?.default}
								</Link>
							</div>
						);
					};
					if (isAuth) {
						if (btn?.id !== "perfil") {
							return card();
						} else if (btn?.id === "perfil" && profileButtonEnabled) {
							return card();
						}
					} else {
						if (btn?.id !== "perfil") {
							return card();
						}
					}
				})}
			</div>
		</>
	);
};
